package storage

import domain.player.GameAction
import domain.player.GraphicsConfig
import domain.player.PlayerProfile
import domain.player.PlayerProfileRepository
import engine.model.HandlingConfig
import kotlinx.browser.localStorage
import kotlinx.serialization.json.Json

class LocalStoragePlayerProfileRepository : PlayerProfileRepository {

    private val json = Json { ignoreUnknownKeys = true }
    private val profileKey = "gravitar_profile"

    override val isLoggedIn: Boolean = true
    override val username: String get() = _profile?.username ?: "guest"

    private var _profile: PlayerProfile? = null

    override fun loadProfile(onResult: (PlayerProfile) -> Unit) {
        val profile = runCatching {
            val raw = localStorage.getItem(profileKey)
            if (raw != null) json.decodeFromString<PlayerProfile>(raw) else PlayerProfile()
        }.onFailure { e ->
            println("LocalStoragePlayerProfileRepository: failed to load profile: ${e.message}")
        }.getOrDefault(PlayerProfile())
        _profile = profile
        onResult(profile)
    }

    override fun saveProfile(profile: PlayerProfile) {
        _profile = profile
        persist(profile)
    }

    override fun updateHandling(handling: HandlingConfig) {
        val updated = (_profile ?: PlayerProfile()).copy(handling = handling)
        _profile = updated
        persist(updated)
    }

    override fun updateGraphics(graphics: GraphicsConfig) {
        val updated = (_profile ?: PlayerProfile()).copy(graphics = graphics)
        _profile = updated
        persist(updated)
    }

    override fun updateKeyBindings(bindings: Map<GameAction, List<String>>) {
        val updated = (_profile ?: PlayerProfile()).copy(keyBindings = bindings)
        _profile = updated
        persist(updated)
    }

    override fun login(username: String, onResult: (PlayerProfile) -> Unit) {
        val profile = (_profile ?: PlayerProfile()).copy(username = username)
        _profile = profile
        persist(profile)
        onResult(profile)
    }

    override fun logout() {
        _profile = PlayerProfile()
        localStorage.removeItem(profileKey)
    }

    override fun resetToDefaults(): PlayerProfile {
        val defaults = PlayerProfile()
        _profile = defaults
        persist(defaults)
        return defaults
    }

    private fun persist(profile: PlayerProfile) {
        runCatching {
            localStorage.setItem(profileKey, json.encodeToString(PlayerProfile.serializer(), profile))
        }.onFailure { e ->
            println("LocalStoragePlayerProfileRepository: failed to save profile: ${e.message}")
        }
    }
}
